import { pxToRem, getClampFullRange } from '~/theme/utils';

export const baseFontSettings = {
    /**
     * @description px value will be converted to rem
     * - '2xs' → 10px
     * - xs → 12px
     * - sm → 14px
     * - md → 16px
     * - lg → 18px
     * - xl → 20px
     * - '2xl' → 24px
     * - '3xl' → 28px
     * - '4xl' → 32px
     * - '5xl' → 36px
     */
    sizes: {
        '2xs': pxToRem('10px'),
        xs: pxToRem('12px'),
        sm: pxToRem('14px'),
        md: pxToRem('16px'),
        lg: pxToRem('18px'),
        xl: pxToRem('20px'),
        '2xl': pxToRem('24px'),
        '3xl': pxToRem('28px'),
        '4xl': pxToRem('32px'),
        '5xl': pxToRem('36px'),
        '6xl': pxToRem('40px'),
    },
    /**
     * @description These sizes scale with the view width.
     * (min)  640px is the cutoff for minimum size, further scaling wont occur below this screenwidth
     * (base) 1920px is desktop size (look at this value if design says something should be e.g. 20px on desktop)
     * (max)  3840px is the cutoff for maximum size, further scaling wont occur above this screenwidth
     * Use the 'min' suffix for fonts that only start scaling from 1920 and up, e.g. 'smMin'
     * - ---- min → base → max
     * - xs: 10px → 12px → 15px
     * - sm: 12px → 14px → 17px
     * - md: 14px → 16px → 19px
     * - lg: 16px → 18px → 21px
     * - xl: 16px → 20px → 26px
     * - '2xl': 18px → 24px → 33px
     * - '3xl': 24px → 28px → 34px
     * - '4xl': 28px → 32px → 38px
     * - '5xl': 32px → 36px → 42px
     */
    sizesFluid: {
        xs: getClampFullRange(10, 12),
        sm: getClampFullRange(12, 14),
        smMin: getClampFullRange(12, 14, 14),
        md: getClampFullRange(14, 16),
        mdMin: getClampFullRange(14, 16, 16),
        lg: getClampFullRange(16, 18),
        lgMin: getClampFullRange(16, 18, 18),
        xl: getClampFullRange(16, 20),
        xlMin: getClampFullRange(16, 20, 20),
        '2xl': getClampFullRange(18, 24),
        '2xlMin': getClampFullRange(18, 24, 24),
        '3xl': getClampFullRange(24, 28),
        '4xl': getClampFullRange(28, 32),
        '5xl': getClampFullRange(32, 36),
        '6xl': getClampFullRange(36, 40),
    },
};

export type FontSizes = { [key in keyof typeof baseFontSettings.sizes]: string };
export type FontSizesFluid = { [key in keyof typeof baseFontSettings.sizesFluid]: string };
export type FontSettings = {
    sizes: FontSizes;
    sizesFluid: FontSizesFluid;
};
